import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SidebarFiltersService } from '@molecules/sidebar-filters/sidebar-filters.service';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { combineLatest, switchMap } from 'rxjs';
import { RoomsOrderService } from 'src/app/services/rooms-order.service';

@Component({
  selector: 'app-sidebar-rooms',
  templateUrl: './sidebar-rooms.component.html',
  styleUrls: ['./sidebar-rooms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RoomsOrderService]
})
export class SidebarRoomsComponent {

  private rooms$ = this.controlPageCardService.rooms$.pipe(
    switchMap(async (rooms) => {
      const roomsOrder = await this.roomsOrderService.getRooms();

      const roomsObject = Object.fromEntries(rooms.map(room => ([room.id, room])));

      return roomsOrder.map(room => roomsObject[room.id]);
    }),
  );

  private filter$ = toObservable(this.sidebarFiltersService.selectedFilter);

  private filteredRooms$ = combineLatest({
    rooms: this.rooms$,
    filter: this.filter$,
  }).pipe(
    switchMap(async ({rooms}) => this.sidebarFiltersService.filterRooms(rooms)),
  );

  viewModel$ = combineLatest({
    filteredRooms: this.filteredRooms$,
  });

  constructor(
    private controlPageCardService: ControlPageCardService,
    private roomsOrderService: RoomsOrderService,
    private sidebarFiltersService: SidebarFiltersService,
  ) { }

}
